.Fieldset {
  place-self: start;
  width: 100%;
  border: none;
  border-radius: 10px;

  [data-slot="control"] + [data-slot="control"] {
    margin-top: var(--space-xs);
  }
}

.FieldsetLegend {
  float: left;
  margin: 0 0 var(--space-sm) var(--space-sm);
  width: 100%;
  font-size: 0.9375rem;
  font-weight: 600;
}
